const validateFile = (file) => {
  const allowedFileTypes = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/svg+xml",
    "image/bmp",
    "image/webp",
    "application/pdf",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ];

  const maxFileSize = 20 * 1024 * 1024; // 20MB en bytes (mismo límite del servidor)

  if (!allowedFileTypes.includes(file.type)) {
    return "Tipo de archivo no permitido, solo se permiten archivos con extensión: jpeg, png, gif, svg, webp, pdf, ppt, pptx";
  }
  if (file.size > maxFileSize) {
    return "El tamaño del archivo supera los 20 MB";
  }
  return true;
};

export { validateFile };
